<template>
  <v-card class="pa-3 overflow-auto" width="100vw" max-width="850" max-height="100vh">
    <v-row class="align-start">
      <v-col cols="12" xxl="8" xl="8" lg="8" md="8" sm="8">
        <v-card>
          <card-header></card-header>
          <v-card-title class="text-h6 font-weight-bold text-information">
            {{ $t("payment-product.title") }}
          </v-card-title>
          <v-card-text class="text-subtitle-2 text-black font-weight-regular">{{
            $t("payment-product.subtitle")
          }}</v-card-text>
          <v-card-item v-if="!isFree">
            <v-list width="auto">
              <template v-for="paymentCategory in paymentMethodCategories" :key="paymentCategory">
                <v-expansion-panels class="px-1">
                  <v-expansion-panel class="my-2 pa-0">
                    <v-expansion-panel-title>
                      <span class="font-weight-medium">
                        {{ paymentCategory }}
                      </span>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                      <v-list-item :disabled="this.$store.state.orderStatus !== null"
                        v-for="paymentMethod in paymentMethods[paymentCategory]" :key="paymentMethod.paymentmethod_id"
                        :value="paymentMethod" :active="paymentMethod?.payment_method ==
                          selectedPaymentMethod?.payment_method
                          " rounded exact @click="selectedPaymentMethod = paymentMethod">
                        <template v-slot:prepend>
                          <div class="d-flex align-center">
                            <template v-for="img in paymentMethod.payment_img_url.split(', ')" :key="img">
                              <v-img class="px-1" @contextmenu.prevent width="50px" :src="img" :lazy-src="img" />
                            </template>
                          </div>
                        </template>
                        <div class="text-body-2">
                          {{ paymentMethod.payment_name }}
                        </div>
                      </v-list-item>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
            </v-list>
          </v-card-item>

          <v-card-item v-else>
            <div class="px-2 text-widget-color font-weight-bold">
              {{ $t("payment-product.free") }}
            </div>
          </v-card-item>
        </v-card>
      </v-col>

      <v-col class="sticky" cols="12" xxl="4" xl="4" lg="4" md="4" sm="4">
        <cart-detail @fetch-payment-method="getPaymentMethods"></cart-detail>
      </v-col>
    </v-row>

    <v-divider class="border-opacity-50 mt-4" thickness="2"></v-divider>

    <v-card-item>
      <card-footer></card-footer>
    </v-card-item>
  </v-card>
</template>

<script>
import CardHeader from "@/components/header/CardHeader.vue";
import CardFooter from "@/components/footer/CardFooter.vue";
import CartDetail from "@/components/cart-detail/CartDetail.vue";
import { PAYMENT } from "@/config/payment";

export default {
  components: { CardHeader, CardFooter, CartDetail },

  data() {
    return {
      allPaymentMethods: [],
      paymentMethodsData: [],
      paymentMethods: [],
      paymentMethodCategories: [],
      selectedPaymentMethod: this.$store.state.selectedPaymentMethod,
      loadingPaymentMethod: true,
      loadingOrder: false,
      merchantCode: null,
      merchantOrderId: null,
      paymentStatus: {
        show: false,
        code: "",
      },
      paymentURL: "",
    };
  },
  computed: {
    totalCartPrice() {
      return this.$store.getters.totalCartPrice;
    },
    discountVoucher() {
      return this.$store.state.discount
    },
    responseVoucher() {
      return this.$store.state.voucher
    },
    cart() {
      return this.$store.getters.sortedCartByTypeID;
    },
    serviceFee() {
      let total = 0
      for (const cartItem of this.cart) {
        let totalPlatformFee = 0
        const platformFee = cartItem.productType.platform_fee_category ?? cartItem.productType.platform_fee_store ?? cartItem.productType.platform_fee_general
        const productTypeTotal = (cartItem.productType.discounted_price ?? cartItem.productType.producttype_price) * cartItem.qty
        if (this.responseVoucher?.producttype_id == cartItem.productType.producttype_id && (this.responseVoucher?.voucher.is_free || this.discountVoucher == productTypeTotal)) {
          totalPlatformFee = 0
        } else if (this.responseVoucher?.producttype_id == cartItem.productType.producttype_id && this.discountVoucher) {
          const discount = productTypeTotal - this.discountVoucher
          totalPlatformFee = Math.round(discount * (platformFee.percentage / 100) + (platformFee.flat_fee ?? 0))
        } else {
          totalPlatformFee = Math.round(productTypeTotal * (platformFee.percentage / 100) + (platformFee.flat_fee ?? 0))
        }
        total += totalPlatformFee
      }
      return total
    },
    paymentFee() {
      return parseInt(this.selectedPaymentMethod?.totalFee || 0);
    },
    step() {
      return this.$store.state.step;
    },
    isFree() {
      return this.totalCartPrice <= 0
    },
    product() {
      return this.$store.state.product;
    },
    appSetting() {
      return this.$store.state.appSetting
    }
  },
  watch: {
    step: {
      deep: true,
      handler(value) {
        if (value == 3) {
          this.getPaymentMethods();
        }
      },
    },
    selectedPaymentMethod: {
      deep: true,
      handler(value) {
        this.$store.commit("setPaymentMethod", value);
      },
    },
    "$store.getters.selectedPaymentMethod": {
      deep: true,
      handler(value) {
        this.selectedPaymentMethod = value;
      },
    },
  },
  created() {
    // this.getPaymentMethods();
    this.getAllPaymentMethods()
  },
  methods: {
    getKeyFromValue(object, value) {
      return Object.keys(object).find((key) => object[key] === value);
    },
    getPaymentGatewayName(payment_gateway) {
      if (payment_gateway == PAYMENT.DUITKU) {
        return "DUITKU";
      }
      if (payment_gateway == PAYMENT.MIDTRANS) {
        return "MIDTRANS";
      }
      return undefined;
    },
    getAllPaymentMethods() {
      const url = "payment/get-method/pg";
      this.axios
        .post(url, {
          pgName: this.getPaymentGatewayName(this.product.store.payment_gateway),
          amount: 10_000
        })
        .then(async (response) => {
          const result = response.data.response;
          let payment_methods = {};
          if (this.appSetting && this.appSetting.paymentmethod_id.length > 0) {
            for (const property in result.payment_methods) {
              let methodsInCategory = result.payment_methods[property];

              methodsInCategory = methodsInCategory.filter((method) =>
                this.appSetting.paymentmethod_id.map(Number).includes(method.paymentmethod_id)
              );

              if (methodsInCategory.length > 0) {
                payment_methods[property] = methodsInCategory;
              }
            }
          } else {
            payment_methods = await this.getPaymentMethods()
          }

          this.paymentMethodCategories = Object.keys(payment_methods);
          this.paymentMethods = payment_methods;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getPaymentMethods() {
      const url = "payment/get-method/product";
      const params = {
        productId: this.product.product_id,
        amount: this.totalCartPrice + this.serviceFee,
        pgName: this.getPaymentGatewayName(this.product.store.payment_gateway),
      };
      try {
        const response = await this.axios.get(url, { params });
        const result = response.data.response;
        const payment_methods = {};
        for (const property in result.payment_methods) {
          let methodsInCategory = result.payment_methods[property];
          if (methodsInCategory.length > 0) {
            payment_methods[property] = methodsInCategory;
          }
        }
        return payment_methods;
      } catch (error) {
        console.log(error);
        return {};
      }
    },
    back() {
      this.$store.commit("backStep");
    },
    next() {
      this.$store.commit("nextStep");
    },
  },
};
</script>

<style></style>